import { useState } from "react";
import styles from "../static/styles/referat.module.css";

// 🔹 Styremøtereferater

import styremote_2020_09_15_pdf from "./download/referat/2020/15.09.2020-Referat-Styremøte.pdf";
import styremote_2022_02_24_pdf from "./download/referat/2022/24.02.2022-Referat-Styremøte.pdf";
import styremote_2021_11_18_odt from "./download/referat/2021/18.11.2021-Referat-Styremøte.odt";
import styremote_2023_02_27_odt from "./download/referat/2023/27.02.2023-Referat-Styremøte.odt";
import styremote_2023_10_16_pdf from "./download/referat/2023/16.10.2023-Referat-Styremøte.pdf";
import styremote_2023_05_24_pdf from "./download/referat/2023/24.05.2023-Referat-Styremøte.pdf";
import styremote_2024_02_20_pdf from "./download/referat/2024/20.02.2024-Referat-Styremøte.pdf";
import styremote_2024_11_18_pdf from "./download/referat/2024/18.11.2024-Referat-Styremøte.pdf";
import styremote_2025_06_11_pdf from "./download/referat/2025/11.06.2025-Referat-Styremøte.pdf";


// 🔹 Årsmøtereferater
import arsmote_2021_pdf from "./download/referat/2021/2021-Årsmøte.pdf";
import arsmote_2020_pdf from "./download/referat/2020/2020-Årsmøte.pdf";
import arsmote_2019_pdf from "./download/referat/2019/2019-Årsmøte.pdf";
import arsmote_2023_pdf from "./download/referat/2023/2023-Årsmøte.pdf";
import arsmote_2024_zip from "./download/referat/2024/2024-Årsmøte-Vedlegg.zip";
import arsmote_2025_zip from "./download/referat/2025/2025-Årsmøte-Vedlegg.zip";
import arsmote_2026_pdf from "./download/referat/2026/2026-Årsmøte.pdf";
import arsmote_2026_2_pdf from "./download/referat/2026/2026-Årsmøte 2.docx";


// 🔹 Årsmeldingar
import arsmelding_2018_pdf from "./download/referat/2018/2018-Årsmelding.pdf";

// 🔸 Innholdslister
const styremøter = [
  { year: "2025", label: "STYREMØTE 11.06.2025", file: styremote_2025_06_11_pdf },
  { year: "2024", label: "STYREMØTE 20.02.2024", file: styremote_2024_02_20_pdf },
  { year: "2024", label: "STYREMØTE 18.11.2024", file: styremote_2024_11_18_pdf },
  { year: "2023", label: "STYREMØTE 16.10.2023", file: styremote_2023_10_16_pdf },
  { year: "2023", label: "STYREMØTE 24.05.2023", file: styremote_2023_05_24_pdf },
  { year: "2023", label: "STYREMØTE 27.02.2023", file: styremote_2023_02_27_odt },
  { year: "2022", label: "STYREMØTE 24.02.2022", file: styremote_2022_02_24_pdf },
  { year: "2021", label: "STYREMØTE 18.11.2021", file: styremote_2021_11_18_odt },
  { year: "2020", label: "STYREMØTE 15.09.2020", file: styremote_2020_09_15_pdf },
];

const årsmøter = [
  { year: "2026", label: "ÅRSMØTE 2, 2026", file: arsmote_2026_2_pdf },
  { year: "2026", label: "ÅRSMØTE 2026", file: arsmote_2026_pdf},
  { year: "2025", label: "ÅRSMØTE 2025", file: arsmote_2025_zip },
  { year: "2024", label: "ÅRSMØTE 2024", file: arsmote_2024_zip },
  { year: "2023", label: "ÅRSMØTE 2023", file: arsmote_2023_pdf },
  { year: "2021", label: "ÅRSMØTE 2021", file: arsmote_2021_pdf },
  { year: "2020", label: "ÅRSMØTE 2020", file: arsmote_2020_pdf },
  { year: "2019", label: "ÅRSMØTE 2019", file: arsmote_2019_pdf },
];

const årsmeldinger = [
  { year: "2018", label: "ÅRSMELDING 2018", file: arsmelding_2018_pdf },
];

// 🔸 Knapp-generering gruppert på år
const renderButtons = (data) => {
    const grouped = data.reduce((acc, item) => {
      acc[item.year] = acc[item.year] || [];
      acc[item.year].push(item);
      return acc;
    }, {});
  
    return (
      <div className={styles.referatGrid}>
        {Object.entries(grouped)
          .sort((a, b) => b[0] - a[0]) // Sorter synkende på år
          .map(([year, items]) => (
            <div key={year} className={styles.referatColumn}>
              <h1 className="light">{year}</h1>
              <div className={styles.btn_list}>
                {items.map((item, idx) => (
                  <a href={item.file} target="_blank" rel="noreferrer" download className={styles.referatButton}>
                  {item.label}
                </a>
                
                ))}
              </div>
            </div>
          ))}
      </div>
    );
  };
  

// 🔸 Hovedkomponent
export default function Info() {
  const [selectedType, setSelectedType] = useState("styre");

  return (
    <div className="content-page">
      <div className="content-wrap">
        <div className="content">
          <div className={styles.this_header}>
            <div className="header1">Referat</div>
          </div>

          <div className={styles.kategorier}>
            <div className={`text2 ${styles.content_item}`}>
              <div style={{ marginBottom: "50px" }}>
                <div htmlFor="referattype">
                  <h1>Velg type:</h1>
                </div>
                <select
                  id="referattype"
                  value={selectedType}
                  onChange={(e) => setSelectedType(e.target.value)}
                  
                >
                  <option value="styre">Styremøtereferat</option>
                  <option value="årsmøte">Årsmøtereferat</option>
                </select>
              </div>

              {selectedType === "styre" && renderButtons(styremøter)}
              {selectedType === "årsmøte" && (
                <>
                  {renderButtons(årsmøter)}
                  <h1  style={{ marginTop: "60px" }}>Årsmeldingar</h1>
                  <div className={styles.btn_list}>
                    {årsmeldinger.map((m, idx) => (
                      
                        <a href={m.file} target="_blank" rel="noreferrer" download className={styles.referatButton}>
                          {m.label}
                        </a>
                      
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
